/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CCPaymentInitializeTerminalSale } from '../models/CCPaymentInitializeTerminalSale';
import type { CCPaymentInitializeTerminalSaleResponse } from '../models/CCPaymentInitializeTerminalSaleResponse';
import type { CCPaymentRetrieveTerminalSaleRequest } from '../models/CCPaymentRetrieveTerminalSaleRequest';
import type { CCPaymentRetrieveTerminalSaleResponse } from '../models/CCPaymentRetrieveTerminalSaleResponse';
import type { CCTokenDetails } from '../models/CCTokenDetails';
import type { CCTokenInitializeTerminalRequest } from '../models/CCTokenInitializeTerminalRequest';
import type { CCTokenInitializeTerminalResponse } from '../models/CCTokenInitializeTerminalResponse';
import type { CCTokenRetrieveTerminalToken } from '../models/CCTokenRetrieveTerminalToken';
import { request as __request } from '../core/request';

export class TerminalsVService {

    /**
     * @param terminalConfigId
     * @param requestBody
     * @returns CCTokenInitializeTerminalResponse OK
     * @throws ApiError
     */
    public static async terminalsVInitializeTerminal(
        terminalConfigId: string,
        requestBody?: CCTokenInitializeTerminalRequest,
    ): Promise<CCTokenInitializeTerminalResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/terminals/${terminalConfigId}/initialize`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns CCTokenDetails OK
     * @throws ApiError
     */
    public static async terminalsVRetrieveTerminalToken(
        requestBody?: CCTokenRetrieveTerminalToken,
    ): Promise<CCTokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/terminals/retrieve_token`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param terminalConfigId
     * @param requestBody
     * @returns CCPaymentInitializeTerminalSaleResponse OK
     * @throws ApiError
     */
    public static async terminalsVInitializeTerminalSale(
        terminalConfigId: string,
        requestBody?: CCPaymentInitializeTerminalSale,
    ): Promise<CCPaymentInitializeTerminalSaleResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/terminals/${terminalConfigId}/initialize_sale`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns CCPaymentRetrieveTerminalSaleResponse OK
     * @throws ApiError
     */
    public static async terminalsVRetrieveTerminalSale(
        requestBody?: CCPaymentRetrieveTerminalSaleRequest,
    ): Promise<CCPaymentRetrieveTerminalSaleResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/terminals/retrieve_sale`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

}